module.exports = __webpack_public_path__ + "img/s75.105ab581.png";